import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Typography, Divider, TextField, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Snackbar, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { deleteProductAssetLinkAPI } from './DesignMgmtAPI';
import { deleteProductassetObj, setProductassetList, setProductSelectImageModal, updateProductObj } from 'store/slice/PharmaSlice';
import { setImageType } from 'store/slice/ImageGallerySlice';
import { getProductassetInfoByProductidandtypeAPI } from '../../../productasset/ProductassetAPI';
import SelectImageActionModal from '../selectImage/SelectImageActionModal';
import ImageIcon from '@mui/icons-material/Image';
import { deleteAPI } from '../../../productasset/ProductassetAPI';
import Alert from '@mui/material/Alert';
import { setSelectedAssetIdList } from 'store/slice/ImageGallerySlice';
import { submitDesignQaApprovalAPI } from 'api/OmsOrdermgmtWebServices';
import CustomerApprovedDesign from './CustomerApprovedDesign';
import { setSnackbarMessage, setSnackbarOpen } from 'store/slice/AppSlice';
import {initRefreshTaskList} from 'store/slice/AppSlice';


export default function DesignerUploadQADesign() {
    const dispatch = useDispatch();
    const { selectedImagePath, selectedImage, imageType } = useSelector((state) => state.imagegalleryslice);
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const { productassetList } = useSelector((state) => state.pharmaslice);
    const [approvalDate, setApprovalDate] = useState('');
    const [viewImage, setViewImage] = useState(null); // {src, name}
    const [deleteDialog, setDeleteDialog] = useState({ open: false, assetObj: null });
    const [selectedImageId, setSelectedImageId] = useState(null);
    const [radioDateError, setRadioDateError] = useState(false);
    const {assetList} = useSelector((state) => state.imagegalleryslice);
    const {snackbarOpen, snackbarMessage} = useSelector((state) => state.appslice);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [AssetForQAApproval, setAssetForQAApproval] = useState([]); // <-- Add this state
    const isQaApproved = productObj?.designstatusqa === "QA APPROVED";
    const {taskList} = useSelector((state) => state.appslice.wkflow);

    useEffect(() => {
        dispatch(setImageType("QA"));
        
    },[]);
    

    useEffect(() => {
        if (productassetList && productassetList.length > 0) {
            dispatch(
                setSelectedAssetIdList(
                    productassetList
                        .filter(obj => obj.imagetype === "QA")
                        .map(obj => obj.assetid)
                        .join(',')
                )
            );
        }
    }, [productassetList]);
    const fetchLinkedAssetSuccessCallBack = (responseObj) => {
        //dispatch(setSelectedAssetObjList(responseObj));
        dispatch(setProductassetList(responseObj));
        dispatch(setSelectedAssetIdList(responseObj.map(obj => obj.assetid).join(',')));
        
    };
    
    useEffect(() => {
        getProductassetInfoByProductidandtypeAPI( "QA",productObj.id, () => { }, fetchLinkedAssetSuccessCallBack)
    }, [])

    const deleteProductAssetLinkSuccessCallBack = (responseObj) => {
        dispatch(deleteProductassetObj(responseObj.id));
    };
    
    const submitForQAApproval = () => {
        const relatedTask = taskList.find(task => task.boobjid === productObj.id);
        submitDesignQaApprovalAPI(
            {
                "productId": productObj.id,
                "taskInstanceId":relatedTask.id
            },
            (response) => {
                dispatch(setSnackbarMessage("Submitted for QA approval successfully."));
                dispatch(setSnackbarOpen(true));
                dispatch(setProductSelectImageModal(false));
                dispatch(updateProductObj(response.productInfo));
                dispatch(initRefreshTaskList()); // Trigger task list refresh
            },
            (error) => {
                console.error("Error submitting for QA approval:", error);
                dispatch(setSnackbarMessage("Error submitting for QA approval."));
                dispatch(setSnackbarOpen(true));
            }
        );
        // You can also dispatch any other actions if needed
    }

    useEffect(() => {
        setAssetForQAApproval(
            (productassetList || []).filter(asset => asset.imagetype === "QA" && asset.designstatus==='')
        );
    }, [productassetList]);

    const confirmDelete = () => {
        if (deleteDialog.assetObj) {
            deleteAPI(deleteDialog.assetObj.id, () => {
                dispatch(deleteProductassetObj(deleteDialog.assetObj.id));
                setDeleteDialog({ open: false, assetObj: null });
                setViewImage(null);
                dispatch(setSnackbarMessage("Asset delinked successfully."));
                dispatch(setSnackbarOpen(true));
            });
        }
    };

    const cancelDelete = () => {
        setDeleteDialog({ open: false, assetObj: null });
    };

    const isQAReadOnly = productObj?.designstatusqa === 'DESIGN WITH QA';

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    
                    overflow: 'hidden',
                    backgroundColor: 'secondary.100',
                    position: 'relative',
                }}
            >
                <Grid
                    container
                    justifyContent="space-between"
                    sx={{
                        height: '100%',
                        width: '100%',
                        margin: 0,
                        flexWrap: { xs: 'wrap', md: 'nowrap' },
                        overflow: 'hidden',
                    }}
                >
                    {/* Section 1: Customer Approved Design */}
                    {/* <Grid
                        item
                        lg={3}
                        xs={12}
                        sm={3}
                        md={3}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0,
                            mt: { xs: 0, md: 0 }, 
                        }}
                    >
                        
                                
                                <Grid container alignItems="center">
                                    <CustomerApprovedDesign/>
                                </Grid>
                           
                    </Grid> */}
                    {/* Section 2: QA Images */}
                    <Grid
                        item
                        lg={12}
                        xs={12}
                        sm={12}
                        md={12}
                        sx={{

                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: 'white',
                                borderRadius: 2,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                border: '1px solid #e0e0e0',
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    mb: 1,
                                    backgroundColor: 'primary.lighter',
                                    p:1
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 'bold',
                                        px: 2,
                                        py: 1,
                                        borderRadius: 1,
                                        display: 'inline-block'
                                    }}
                                >
                                    Assets for QA Approval
                                </Typography>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<ImageIcon />}
                                    onClick={() => {
                                        dispatch(setProductSelectImageModal(true));
                                        dispatch(setImageType("QA"));
                                    }}
                                    disabled={isQAReadOnly || isQaApproved} // <-- disable if QA is read-only or QA APPROVED
                                >
                                    Asset Library
                                </Button>
                            </Box>
                            <Divider sx={{}} />
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    borderRadius: 2,
                                    overflowY: 'auto',
                                    backgroundColor: 'white',
                                    height: '100%',
                                    maxHeight: { lg: '58vh', md: '60vh', sm:'60vh', xs: '40vh',  }, // Add a maxHeight for scrolling
                                }}
                            >
                                <Grid container sx={{ width: '100%' }} justifyContent="space-between" alignItems="center">
                                    {AssetForQAApproval.length > 0 ? AssetForQAApproval.map(productAssetObj => (
                                        <Grid item key={productAssetObj.id} lg={12}  md={4} sm={6}  xs={12} sx={{ p: 1 }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    p: 1,
                                                    borderRadius: 2,
                                                    transition: 'box-shadow 0.2s, background 0.2s, border 0.2s',
                                                    backgroundColor: 'secondary.100',
                                                    border: selectedImageId === productAssetObj.id ? '1px solid #0050b3' : '1px solid transparent',
                                                    boxShadow: selectedImageId === productAssetObj.id ? 3 : 0,
                                                    '&:hover': {
                                                        //backgroundColor: 'primary.lighter',
                                                    },
                                                    cursor: 'pointer',
                                                    position: 'relative'
                                                }}
                                                onClick={() => setViewImage({ src: productAssetObj.assetpath, name: productAssetObj.name, id: productAssetObj.id })}
                                                onMouseEnter={() => setSelectedImageId(productAssetObj.id)}
                                                onMouseLeave={() => setSelectedImageId(null)}
                                            >
                                                <img
                                                    src={productAssetObj.assetpath}
                                                    style={{
                                                        width: '200px',
                                                        height: '200px',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer'
                                                    }}
                                                    alt={productAssetObj.name}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    noWrap
                                                    title={productAssetObj.name}
                                                    sx={{
                                                        maxWidth: '200px',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        display: 'block',
                                                        mt: 1,
                                                        color: '#1976d2',
                                                        textAlign: 'center',
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {productAssetObj.name}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    )) : (
                                        <Grid item xs={12} sx={{padding:5, minHeight:'200px', justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                                            <Typography variant="h5" color="text.secondary" sx={{borderRadius:5, padding:10, backgroundColor:'secondary.100',}}>
                                                
                                                Click on 'Asset Library' Button to Upload / Select Assets.
                                            </Typography>
                                            
                                        </Grid>
                                    )}
                                </Grid>
                            </Box>
                             <Divider sx={{}} />
                            {/* Replace LK with the button at the bottom right */}
                            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setConfirmDialogOpen(true)}
                                    sx={{
                                        minWidth: 220,
                                        boxShadow: 3,
                                    }}
                                    disabled={isQAReadOnly || isQaApproved || AssetForQAApproval.length === 0} // Disable if QA is read-only, QA APPROVED or no assets for approval
                                >
                                    Submit for QA Approval
                                </Button>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Spacer: 5% */}
                    {/* <Grid
                    item
                    md={1}
                    sx={{
                        display: { xs: 'none', md: 'block' },
                        flexBasis: { md: '5%' },
                        maxWidth: { md: '5%' }
                    }}
                /> */}

                    

                    {/* Image View Dialog */}
                    <Dialog
                        open={!!viewImage}
                        onClose={() => setViewImage(null)}
                        maxWidth={false}
                        PaperProps={{
                            sx: {
                                width: 'auto',
                                maxWidth: '90vw',
                                minWidth: '320px',
                                p: 0,
                                borderRadius: 2,
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, pb: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                {viewImage?.name || "Image"}
                            </Typography>
                            <IconButton onClick={() => setViewImage(null)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Divider />
                        <DialogContent
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                p: 3,
                                minWidth: '320px',
                                minHeight: '200px',
                                maxWidth: '80vw',
                                maxHeight: '70vh',
                            }}
                        >
                            <img
                                src={viewImage?.src}
                                alt={viewImage?.name}
                                style={{
                                    //maxWidth: '70vw',
                                    //maxHeight: '60vh',
                                    display: 'block',
                                    margin: '0 auto'
                                }}
                            />
                        </DialogContent>
                        <Divider />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: 2, pt: 1 }}>
                            <Button
                                onClick={() => setDeleteDialog({ open: true, assetObj: { id: viewImage?.id, assetpath: viewImage?.src, assetname: viewImage?.name } })}
                                color="error"
                                variant="contained"
                                startIcon={<DeleteIcon />}
                                disabled={isQAReadOnly}
                            >
                                De-link from Product
                            </Button>
                        </Box>
                        {/* Delete Confirmation Dialog as modal over image dialog */}
                        <Dialog
                            open={deleteDialog.open}
                            onClose={cancelDelete}
                            maxWidth="xs"
                            PaperProps={{
                                sx: {
                                    zIndex: 1601, // higher than the image dialog
                                }
                            }}
                        >
                            <DialogTitle>Confirm Delink</DialogTitle>
                            <DialogContent>
                                <Typography>Are you sure you want to delink '{viewImage?.name || "Asset"}' from the Product?</Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={cancelDelete} color="primary">Cancel</Button>
                                <Button onClick={confirmDelete} color="error" variant="contained">De-link from Product</Button>
                            </DialogActions>
                        </Dialog>
                    </Dialog>



                    {/* Existing modal and other logic */}
                    <SelectImageActionModal />
                </Grid>
            </Box>
            
            
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={10000}
                onClose={() => dispatch(setSnackbarOpen(false))}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Snackbar
                open={radioDateError}
                autoHideDuration={10000}
                onClose={() => setRadioDateError(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setRadioDateError(false)}
                    severity="error"
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    Please select a date before selecting customer approval
                </Alert>
            </Snackbar>

            {/* Confirmation Dialog */}
            <Dialog
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
                maxWidth="xs"
            >
                <DialogTitle>Confirm Submission</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to submit for QA Approval?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDialogOpen(false)} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            setConfirmDialogOpen(false);
                            submitForQAApproval();
                        }}
                        color="primary"
                        variant="contained"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}